














import { Component, Mixins } from "vue-property-decorator";
import Customizer from "@/components/Customizer/Container.vue";
import { currentUserStore, customizationStore } from "@/store/typed";
import ProductMixin from "@/mixins/http/ProductMixin";
import { DEFAULT_PRODUCT_ID } from "@/constants";
import IlmyoLoader from "@/components/Common/IlmyoLoader.vue";
import { isMobile } from "@/helpers/mediaQueryHelper";
import Error from "@/components/Common/Error.vue";

@Component({
  components: {
    Customizer,
    IlmyoLoader,
    Error,
  },
})
export default class Configurator extends Mixins(ProductMixin) {
  private canShowConfigurator = false;
  private loadError = null;

  get product() {
    return customizationStore.product;
  }

  get printArea() {
    return customizationStore.printArea;
  }

  get clipArea() {
    return this.printArea?.clipArea;
  }

  get userLang(): string | null {
    return currentUserStore.lang;
  }

  mounted() {
    this.canShowConfigurator = true;
    this.setBasicStoreData();
  }

  get isMobile() {
    return isMobile((this as any).$mq);
  }

  private setBasicStoreData() {
    const url = window.location.href;
    let sanitizedUrl = url.replace(/(^\w.+:|^)\/\//, "");
    const [leftUrlSide, rightUrlSide] = sanitizedUrl.split("?");
    this.handleQueryParams(rightUrlSide);
  }

  private async handleQueryParams(splittedUrlPath: string | null | undefined) {
    if (!splittedUrlPath) {
      customizationStore._setProduct({
        id: DEFAULT_PRODUCT_ID,
        reloadCustomization: true,
      });
      return;
    }

    const queryParams = splittedUrlPath.split("&");
    const queryParamsMap = new Map<string, string>();
    queryParams.forEach((qp) => {
      const keyValue = qp.split("=");
      queryParamsMap.set(keyValue[0] || "", keyValue[1] || "");
    });
    const productId = queryParamsMap.get("productId") || DEFAULT_PRODUCT_ID;
    const previewMode = !!queryParamsMap.get("shared") || false;
    const editMode = !!queryParamsMap.get("edit") || false;
    const productCustomizationId =
      queryParamsMap.get("productCustomizationId") || null;
    try {
      await customizationStore._setProduct({
        id: productId,
        reloadCustomization: true,
        productCustomizationId: productCustomizationId,
      });
    } catch (e) {
      console.log(e);
      this.loadError = true;
    }
    customizationStore.setEditMode(editMode);
    customizationStore.setPreviewMode(previewMode);
  }
}
